<template lang="pug">
.mb-2
  .panel
    .panel-header
      .panel-title.h4 Informações por idioma
      .panel-nav
        ul.tab.tab-block
          li.tab-item(v-for="(language, key) in languages" :key="language" :class="{active: active === key}")
            a.c-hand(@click="active = key") {{ language }}
      .panel-body
        div(v-for="(info, index) in value" v-if="active === info.language")
          form-group(:label="`Título ${languages[info.language]}`")
            input.form-input(v-model="value[index].title")
          form-group(:label="`Resumo ${languages[info.language]}`")
            textarea.form-input(v-model="value[index].brief")
</template>

<script>
export default {
  data() {
    return {
      languages: { pt: 'Português', en: 'Inglês', es: 'Espanhol' },
      active: 'pt',
    }
  },
  props: {
    value: { type: Array, required: true },
  },
}
</script>
